import React, { Component } from 'react';
import { Container } from 'reactstrap';

export default class Footer extends Component {
  render() {
    return (
      <footer>
        <Container style={footer}>
        Copyright © 2011 PT Yakin Bertumbuh Sekuritas. All Rights Reserved. <br />
        Member of Indonesia Stock Exchange
        </Container>
          </footer>
    )
  }
}

const footer = {
  paddingTop: '20px',
  paddingBottom: '20px',
  backgroundColor: '#3e3e3e',
  color: '#ffffff',
  fontSize: '0.7em'
}



// WEBPACK FOOTER //
// ./src/components/Footer.js